import { Component, Input, OnInit } from '@angular/core';
import * as QRCode from 'qrcode';
import { UserService } from '@services/user.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.scss'],
    standalone: false
})
export class QrCodeComponent implements OnInit {
  @Input() secretCode = '';
  mfaSecret: string = '';
  qrCodeUrl: string = '';
  constructor(private userService: UserService) {}
  ngOnInit(): void {
    this.userService
      .getRoleDetails()
      .pipe(take(1))
      .subscribe(details => {
        const otpauthUrl = `otpauth://totp/AWS:${encodeURIComponent(
          `${details.cognito_username || 'user'}-${
            window?.location?.hostname
          }-"Scaffold"`
        )}?secret=${this.secretCode}&issuer=AWS`;
        QRCode.toDataURL(otpauthUrl, (error, url) => {
          if (error) {
            console.error('Error generating QR code:', error);
          } else {
            this.qrCodeUrl = url;
          }
        });
      });
  }
}
